/* jshint ignore:start */
if (typeof define !== 'function') {
    var define = require('amdefine')(module)
}
/* jshint ignore:end */

define('pdfGear/generator/docDefinition',['./header', './footer', './content', './dashboard', './chart', './zoning'],
    function(header, footer, content, dashboard, chart, zoning) {
        'use strict';

        return {
            createDocDefinition: createDocDefinition
        };

        /**
         * Function to create document definition object according to pdfmake library format
         * @param  inputData contains all the raw data to be used for preparing the pdf file
         * @return array of javascript objects formatted according to pdfmake formatting
         */
        function createDocDefinition(inputData) {
            var docDefinition = {
                pageMargins: [40, 110, 40, 60],
                header: header.getHeader(inputData),
                footer: footer.getFooter(inputData),
                content: content.createDocumentContent(inputData.widgets),
                //global styles
                styles: {
                    bulletMessageStyle: content.bulletMessageStyle,
                    chartHeaderStyle: header.chartHeaderStyle,
                    chartTitleStyle: chart.chartTitleStyle,
                    chartTextStyle: chart.chartTextStyle
                }
            };
            return docDefinition;
        }
    });
